import React from "react"

import styles from "./SalonSettingsTable.module.scss"
import { AUTO_CLAIM_BASE_LABEL } from "./labelMaps"

import {
	FragmentType,
	getFragmentData,
	graphql,
} from "@/souhl_admin/gql/__generated__"
import { CompanySmsSendingRuleAutoClaimBase } from "@/souhl_admin/gql/__generated__/graphql"

export type SalonRow = {
	id: number
	name: string
	displayName: string
	autoClaimBase: CompanySmsSendingRuleAutoClaimBase
	autoClaimStartDate: string | null
	encourageStartCancelDate: string | null
}

const smsSendingStartSettingsTableFragment = graphql(/* GraphQL */ `
	fragment smsSendingStartSettingsTable on Salon {
		id
		name
		displayName
		autoClaimBase
		autoClaimStartDate
		encourageStartCancelDate
	}
`)

type Props = {
	fragment: readonly FragmentType<typeof smsSendingStartSettingsTableFragment>[]
	selected: Record<number, boolean>
	onToggle: (salonId: number, checked: boolean) => void
	onToggleAll?: (checked: boolean) => void
}

const SalonSettingsTable: React.FC<Props> = ({
	fragment,
	selected,
	onToggle,
	onToggleAll,
}) => {
	const salons = getFragmentData(smsSendingStartSettingsTableFragment, fragment)
	const allChecked = salons.length > 0 && salons.every((s) => selected[s.id])
	return (
		<div className={styles.table_wrapper}>
			<table className={styles.table}>
				<thead>
					<tr>
						<th className={`${styles.th} ${styles.header_cell}`}>
							<input
								type="checkbox"
								checked={allChecked}
								onChange={(e) => onToggleAll?.(e.target.checked)}
								aria-label="全選択"
							/>
						</th>
						<th className={`${styles.th} ${styles.header_cell}`}>店舗名</th>
						<th className={`${styles.th} ${styles.header_cell}`}>
							自動請求開始基準
						</th>
						<th className={`${styles.th} ${styles.header_cell}`}>請求開始日</th>
						<th className={`${styles.th} ${styles.header_cell}`}>
							再予約開始日
						</th>
					</tr>
				</thead>
				<tbody>
					{salons.map((s) => (
						<tr key={s.id}>
							<td className={styles.td}>
								<input
									type="checkbox"
									checked={!!selected[s.id]}
									onChange={(e) => onToggle(s.id, e.target.checked)}
									aria-label={`選択: ${s.displayName}`}
								/>
							</td>
							<td className={styles.td}>{s.displayName}</td>
							<td className={styles.td}>
								{AUTO_CLAIM_BASE_LABEL[s.autoClaimBase] || "-"}
							</td>
							<td className={styles.td}>{s.autoClaimStartDate ?? "-"}</td>
							<td className={styles.td}>{s.encourageStartCancelDate ?? "-"}</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	)
}

export default SalonSettingsTable
